export default "32a3f11e7740ce58.woff2"